import type { IncomingHttpHeaders } from 'http';
import UAParser from 'ua-parser-js';

export const getDeviceInformation = (
  headers: IncomingHttpHeaders,
): { os: { name: string | null; version: string | null } } => {
  try {
    const userAgent = headers['user-agent'];
    const parser = new UAParser();
    const ua = userAgent;
    const { name, version } = parser.setUA(ua || '').getOS();
    return { os: { name: name?.toLowerCase() ?? null, version: version ?? null } };
  } catch (_error) {
    return { os: { name: null, version: null } };
  }
};

export default getDeviceInformation;
